/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { DateTime } from 'luxon'
import { useMemo } from 'react'
import { FormattedMessage } from 'react-intl'
import { Badge, BadgeProps } from '@mantine/core'

export type InterventionStatusBadgeProps = BadgeProps & {
  intervention: Intervention
}

function InterventionStatusBadge (props: InterventionStatusBadgeProps) {
  const { intervention, ...others } = props

  const { startDate, endDate } = intervention

  const hasEnded = useMemo(() => {
    const dateTime = DateTime.fromISO(endDate)
    return dateTime.isValid && dateTime <= DateTime.now()
  }, [endDate])

  const hasStarted = useMemo(() => {
    const dateTime = DateTime.fromISO(startDate)
    return dateTime.isValid && dateTime <= DateTime.now()
  }, [startDate])

  const isComing = useMemo(() => {
    const dateTime = DateTime.fromISO(startDate)
    return dateTime.isValid && dateTime > DateTime.now()
  }, [startDate])

  if (hasEnded) {
    return (
      <Badge {...others} color="gray">
        <FormattedMessage
          id="finished"
          defaultMessage="Terminé"
        />
      </Badge>
    )
  }

  if (hasStarted) {
    return (
      <Badge {...others} color="blue">
        <FormattedMessage
          id="ongoing"
          defaultMessage="En cours"
        />
      </Badge>
    )
  }

  if (isComing) {
    return (
      <Badge {...others} color="orange">
        <FormattedMessage
          id="to_come_up"
          defaultMessage="À venir"
        />
      </Badge>
    )
  }

  return (
    <Badge {...others} color="yellow">
      <FormattedMessage
        id="unknown"
        defaultMessage="Inconnu"
      />
    </Badge>
  )
}

export default InterventionStatusBadge
